import { format } from "date-fns";
import { ReportFilterStateActions, ReportFilterStateActionsType } from "./types";
import { ReportFilterState } from "src/components/manufacturer/reportFilters/types";



export const initialState: (isZilrettaUser: boolean) => ReportFilterState = (isZilrettaUser: boolean) => ({
  start_date: format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
  end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
  //case_id: "",
  //doctor_name:"",
  practice_id: "",
  //patient_id:"",
  report_name:"",
  file_required:false,
  drug_name: isZilrettaUser ? "zilretta" : "All Product",
  global_doctor_ids:"",
 //global_patient_external_id:"",
  page:1,
  pagination:true,
  insurance_name:''
});

export const tableFilterReducer = (state: ReportFilterState, action: ReportFilterStateActionsType): ReportFilterState => {
  switch (action.type) {
    case ReportFilterStateActions.SET_QUERY_PARAMS:
      return {
        ...state,
        ...action.payload,
      };
    case ReportFilterStateActions.CHANGE_REPORT_NAME:
      return {
        ...state,
        report_name:action.payload,
      };
       case ReportFilterStateActions.CHANGE_PAGE:
            return {
              ...state,
              page: action.payload
            };
            case ReportFilterStateActions.CHANGE_PAGINATION_BIT:
            return {
              ...state,
              pagination: action.payload,
            }
      
      

    default:
      return state;
  }
};
